import { API_HOST_NAME } from "../../constants.js"
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js"

const useServiceLogsResources = (teamId, projectId, serviceId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/projects/${projectId}/services/${serviceId}/logs`
  return useAuthenticatedResources(url)
}

export default useServiceLogsResources
